import { css } from '@emotion/react';
import { themed } from '@spotnana/blocks/src/utils/styling';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const secureInputCSS = {
  border: 0,
  backgroundColor: 'transparent',
  appearance: 'none',
  height: 48,
  outline: 0,
  alignSelf: 'flex-end',
  width: '100%',
  paddingLeft: 16,
  fontSize: 16,
  boxSizing: 'border-box',
};

export const secure_input_container = (error: boolean) =>
  themed(
    ({ palette }) => css`
      width: 100%;
      height: 3rem;
      position: relative;
      border-radius: 8px;
      border: 1px solid ${palette.border.light};
      overflow: hidden;
      align-items: center;
      cursor: pointer;
      outline: initial;
      background-color: ${palette.surface.base};
      border-color: ${error ? palette.border.error : palette.border.light};

      &:hover {
        border-color: ${palette.border.medium};
        background-color: ${palette.surface.background};
      }
    `,
  );

export const vgs_field_content_iframe = css`
  ${paddings.xr.compact}

  & iframe {
    height: 3rem;
    width: 100%;
  }
`;
